export class EmailContentAttachmentParameterDto {
    emailCacheId: number;
    fileName: string;
    emailAccount: string;
    clearCache = false;

    getQueryParams(): string {
        const tokens = [`emailCacheId=${this.emailCacheId}`, `fileName=${encodeURIComponent(this.fileName)}`];
        if (!!this.emailAccount) {
            tokens.push(`emailAccount=${this.emailAccount}`);
        }
        tokens.push(`clearCache=${this.clearCache}`);
        return tokens.join('&');
    }
}
